import {
  Component,
  forwardRef,
  Inject,
  Input
}                             from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslateService }   from '@ngx-translate/core';

import { AdminDashboardService } from './admin-dashboard.service';
import { ConfirmService }        from '../messages/confirm/confirm.service';
import { MessagesService }       from '../messages/messages.service';

@Component({
  selector   : 'wor-admin-dashboard-session-management',
  template: require('./admin-dashboard.session-management.component.html')
})
export class SessionManagementComponent {
  @BlockUI('sessionManagementBlock') block : NgBlockUI;

  @Input() company : any;

  constructor (
    @Inject(forwardRef(() => AdminDashboardService))
    private adminDashboardService : AdminDashboardService,
    private confirmService        : ConfirmService,
    private messagesService       : MessagesService,
    private translateService      : TranslateService
  ) {}

  killCompanySessions () : void {
    const message = this.translateService.instant(
      'DASHBOARD_SPACE.ADMIN_DASHBOARD.SESSIONS.KILL_CONFIRM',
      { companyName: this.company.company_name }
    );

    this.confirmService.generic(message)
    .then(() => {
      this.block.start();

      return this.adminDashboardService.killCompanySessions(this.company.id);
    })
    .then(( response : any ) => this.messagesService.show(response.message, 'success'))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
